import { useState } from 'react';
import Hero from './components/Hero';
import Introduction from './components/Introduction';
import Products from './components/Products';
import Features from './components/Features';
import Summary from './components/Summary';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  const [activeSection, setActiveSection] = useState('home');

  return (
    <div className="min-h-screen bg-white">
      <nav className="fixed top-0 left-0 right-0 bg-[#FFFFFF] shadow-lg z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <div className="flex items-center space-x-3">
              <img 
                src="https://static.readdy.ai/image/0eb722bc6d334a4c0ff7cf36fa5a7e2c/6231b55b65561184d9e387b98fd52d79.png" 
                alt="Reda & Naoual Logo" 
                className="h-14 w-auto"
              />
            </div>
            
            <div className="hidden md:flex items-center space-x-8">
              <a 
                href="#home" 
                onClick={() => setActiveSection('home')}
                className={`text-[#1E3A5F] hover:text-[#A83232] transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer ${activeSection === 'home' ? 'text-[#A83232]' : ''}`}
              >
                Accueil
              </a>
              <a 
                href="#introduction" 
                onClick={() => setActiveSection('introduction')}
                className={`text-[#1E3A5F] hover:text-[#A83232] transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer ${activeSection === 'introduction' ? 'text-[#A83232]' : ''}`}
              >
                À Propos
              </a>
              <a 
                href="#products" 
                onClick={() => setActiveSection('products')}
                className={`text-[#1E3A5F] hover:text-[#A83232] transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer ${activeSection === 'products' ? 'text-[#A83232]' : ''}`}
              >
                Produits
              </a>
              <a 
                href="#contact" 
                onClick={() => setActiveSection('contact')}
                className={`text-[#1E3A5F] hover:text-[#A83232] transition-colors duration-300 font-medium whitespace-nowrap cursor-pointer ${activeSection === 'contact' ? 'text-[#A83232]' : ''}`}
              >
                Contact
              </a>
            </div>

            <button className="md:hidden text-[#1E3A5F] w-10 h-10 flex items-center justify-center cursor-pointer">
              <i className="ri-menu-line text-2xl"></i>
            </button>
          </div>
        </div>
      </nav>

      <div className="pt-20">
        <Hero />
        <Introduction />
        <Products />
        <Features />
        <Summary />
        <Contact />
        <Footer />
      </div>
    </div>
  );
}
